import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { MortgageAnnotations } from '@cian/adfox-templates';
import { UIText3 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { TMainpageBrandContext } from '../../../types/adfox';
import { Ticker } from '../../Ticker';

type TBrandBannerProps = {
  sizes: TAdFoxBannerCompleteSizes;
  context: TMainpageBrandContext;
};

export function BrandBanner({ context, sizes }: TBrandBannerProps) {
  const { url, bgImageUrl, logoImageUrl, actionText, note, label, name, mortgageTermsWarning, mortgageWarning } =
    context;

  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <div
      className={cn(styles['container'], !mortgageTermsWarning && styles['container-without-mortgage-terms-warning'])}
      style={{ ...sizes, backgroundImage: `url(${bgImageUrl})` }}
      data-testid="BrandBanner"
    >
      <a href={url} target="_blank" rel="noopener noreferrer nofollow" className={styles['link']}>
        <div className={styles['main']}>
          <div className={styles['content']}>
            {logoImageUrl && (
              <div className={styles['logo']}>
                <img src={logoImageUrl} alt={name} className={styles['logo-image']} />
              </div>
            )}
            <div className={styles['content-text']}>
              <UIText3 color="white_100">{actionText}</UIText3>
            </div>
          </div>
          {label && <div className={styles['label']}>{label}</div>}
        </div>

        {(note || withMortgageAnnotations) && (
          <div className={styles['disclaimers-wrapper']}>
            {note && (
              <div data-testid="disclaimer" className={styles['disclaimer']}>
                <Ticker paddingLeft={8} text={note} />
              </div>
            )}

            {withMortgageAnnotations && (
              <div data-testid="mortgage-disclaimers-wrapper" className={styles['mortgage-disclaimer']}>
                <MortgageAnnotations
                  height={sizes.height}
                  splitMortgageTermsWarning
                  mortgageWarning={mortgageWarning}
                  mortgageTermsWarning={mortgageTermsWarning}
                />
              </div>
            )}
          </div>
        )}
      </a>
    </div>
  );
}
